<template>
    <infinite-scroller-horizontal @scrolledTillRight="scrolledTillRight">
        <template>
            <v-col v-for="(n,index) in listItems" :key="'stor-' + index">
                <v-card width="180px" flat>
                    <v-img height="180" src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" class="white--text align-start" gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                        <v-list-item two-line>
                            <v-list-item-avatar color="white">
                                <span>N</span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="white--text">Two-line item</v-list-item-title>
                                <v-list-item-subtitle class="caption white--text">Nirmal Premnath</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-img>
                </v-card>
            </v-col>
        </template>
    </infinite-scroller-horizontal>
</template>
<script>
export default {
    data: () => ({
        listItems: 10
    }),
    methods: {
        profile() {},

        scrolledTillRight(val) {
            if (val) {
                this.listItems += 10
            }
        }
    }
}
</script>